import {
  computed,
  onBeforeUnmount,
  ref,
  useStore,
  watch
} from '@nuxtjs/composition-api'

export default function useFinancialSuccess() {
  const store = useStore()

  const websocket$ = computed(() => store.state.websocketModule.websocket$)

  const listener = ref(null)

  watch(websocket$, (newVal, oldVal) => {
    if (oldVal === null) {
      listening()
    }
    if (newVal === null) {
      stopListening()
    }
  })

  onBeforeUnmount(() => {
    stopListening()
  })

  function listening() {
    listener.value = websocket$.value.subscribe({
      next: msg => {
        if (msg.action === 'first_deposit_success') {
          window.dataLayer &&
            window.dataLayer.push({
              event: 'firstDepositSuccessEvent',
              username: msg.loginname,
              price: msg.money
            })
        } else if (msg.action === 'deposit_success') {
          window.dataLayer &&
            window.dataLayer.push({
              event: 'depositSuccessEvent',
              username: msg.loginname,
              price: msg.money
            })
        } else if (msg.action === 'withdraw_success') {
          window.dataLayer &&
            window.dataLayer.push({
              event: 'withdrawalSuccessEvent',
              username: msg.loginname,
              price: msg.money
            })
        }
      },
      error: err => {
        console.error(err)
      }
    })
  }
  function stopListening() {
    if (listener.value) {
      listener.value.unsubscribe()
    }
  }

  return {}
}
